<template>
  <b-overlay :show="show" rounded="md" :shown="shown()">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>

      <b-row align-h="center" style="width: 100%; margin-top: 60px; ">
        <b-col cols="12" style="padding-top: 5px" class="pl-0 pr-0 cart-nav">
          <b-row style="width: 100%">
            <b-col lg="6" class="pl-pr-0-sm hide-when-big">
              <b-row
                class="pl-3 pt-0 reduced_pl_pr"
                style="font-size: 28px; padding-bottom: 1px"
              >
                <b style="font-size: 33px; padding-bottom: 1px" class="h1-font"
                  >Truthbrush Skin</b
                >
              </b-row>
              <b-row class="mb-2">
                <b-col style="max-width: 500px" class="pl-pr-0-sm">
                  Add more fun to your brushing with colorful Truthbrush skins!  Work with both Truthbrush Classic trackers and Truthbrush Pro Trackers.  Easy to replace and clean.  Collect them all!

                </b-col>
              </b-row>
            </b-col>

            <b-col
              lg="6"
              style="
                border-radius: 25px;
                border: 0px solid;
                padding-left: 0;
                padding-right: 0;
              "
              class=""
            >
              <b-row>
                <b-col class="pt-0 pb-0 pl-pr-0-sm">
                  <b-img
                    :src="selectedimage()[hoverindex]"
                    fluid
                    rounded
                    center
                    :class="{ 'reduced-padding-thumbnail': hoverindex >= 3 }"
                    style="max-width: 100%; max-height: 512px; padding: 10%"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row class="pt-4 pl-3 pr-3 pl-pr-0-sm">
                <b-col
                  v-for="(item, index) in selectedimage()"
                  :key="index"
                  @mouseover="hoversample(index)"
                  class="pl-1 pr-1"
                  align-self="center"
                >
                  <b-img
                    :src="item"
                    fluid
                    rounded
                    :class="{ 'underline-blue': hoverindex == index }"
                    class="thumbnail-skin"
                    center
                    style="max-height: 80px"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row class="pt-5" style="justify-content: center">
                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/worldwide.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    Worldwide Shipping
                  </b-row>
                </b-col>

                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/fastdelivery.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    Fast Delivery
                  </b-row>
                </b-col>
                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/7dayreturn.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    30 Day Guarantee
                  </b-row>
                </b-col>
                <b-col cols="3">
                  <b-row>
                    <b-img
                      src="img/warranty.png"
                      style="height: 48px; height: 48px"
                      center
                    ></b-img>
                  </b-row>
                  <b-row
                    class="pt-3"
                    style="justify-content: center; text-align: center"
                  >
                    Factory Warranty
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pt-1">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>
              <b-row class="pl-3 reduced_pl_pr hide-when-small">
                Have questions? We can help.
                <a href="/#/contact" style="padding-left: 6px"> Contact us</a>
              </b-row>
            </b-col>

            <b-col lg="6" class="pl-pr-0-sm">
              <b-row
                class="pl-3 pt-5 reduced_pl_pr hide-when-small"
                style="font-size: 28px; padding-bottom: 1px"
                data-aos="fade-left"
                data-aos-delay="250"
              >
                <b style="font-size: 33px; padding-bottom: 1px" class="h1-font"
                  >Truthbrush Skin</b
                >
              </b-row>
              <b-row class="mb-2 hide-when-small">
                <b-col style="max-width: 500px" class="pl-pr-0-sm">
                  Add more fun to your brushing with colorful Truthbrush skins!  Work with both Truthbrush Classic trackers and Truthbrush Pro Trackers.  Easy to replace and clean.  Collect them all!

                </b-col>
              </b-row>

              <b-row class="pt-1 hide-when-small">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row
                class="pl-3 pt-2 h3-font reduced_pl_pr"
                style="font-size: 22px; padding-bottom: 1px"
                data-aos="fade-left"
                data-aos-delay="350"
              >
                Please select your skin design
              </b-row>
              <b-row
                class="pl-3 pt-0 reduced_pl_pr"
                style="font-size: 22px; padding-bottom: 10px"
                data-aos="fade-left"
                data-aos-delay="450"
              >
                <a href="#/select">Are you looking for trackers instead？</a>
              </b-row>
              <b-row
                class="pl-3 pr-3 pt-3 reduced_pl_pr no-max-width-small"
                style="max-width: 500px"
              >
                <b-col
                  class="pb-2 pl-2 pr-2"
                  lg="3"
                  cols="3"
                  v-for="(item, index) in getskinskulist()"
                  :key="index"
                  @click="clicksku(index)"
                >
                  <b-img
                    :src="item.images[1]"
                    fluid
                    center
                    :class="{ activeskuskin: getselectedsku(index) }"
                    class="inactiveskuskin swatch-thumbnail"
                  ></b-img>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="pt-3" hidden>
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>
              <b-row class="pt-2 pl-3 reduced_pl_pr"> </b-row>
              <b-row
                class="pt-0 pb-3 pl-3 reduced_pl_pr"
                v-if="
                  getDiscountSkinPrice(false) - getDiscountSkinPrice(true) >
                  0.000001
                "
              >
                <b style="font-size: 24px" class="h3-font">{{
                  getproductInfo()
                }}</b>
                <span class="pl-2">
                  <b style="font-size: 24px" class="h3-font">
                    ${{ getDiscountSkinPrice(true) }}
                  </b>
                  <strike>${{ getDiscountSkinPrice(false) }}</strike>
                </span>
              </b-row>
              <b-row class="pt-0 pb-3 pl-3 reduced_pl_pr" v-else>
                <b style="font-size: 24px" class="h3-font">{{
                  getproductInfo()
                }}</b>
                <span class="pl-2">
                  <b style="font-size: 24px" class="h3-font">
                    ${{ getDiscountSkinPrice(false) }}
                  </b>
                </span>
              </b-row>
              <b-row class="pt-2">
                <b-col md="12" class="reduced_pl_pr">
                  <b-button
                    pill
                    class="full-width blue-button"
                    v-if="getStock() > 0"
                    v-on:click="onAddCart()"
                  >
                    <span style="font-size: 18px">Add to Cart</span>
                  </b-button>
                  <b-button
                    pill
                    disabled
                    class="full-width blue-button"
                    style="
                      background-color: #12b8ed;
                      border: none;
                      padding: 10px 30px;
                    "
                    v-else
                  >
                    <span class="">Sold Out</span>
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="pt-3">
                <b-col cols="12" class="reduced_pl_pr">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      max-width: 496px;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>

              <b-row class="pt-2 pb-3 pl-3 reduced_pl_pr" hidden>
                <b-col
                  class="col-2 reduced_pl_pr pl-0 pr-0"
                  align-self="center"
                >
                  <b-img
                    src="img/box1.png"
                    style="height: 48px; height: 48px"
                  ></b-img>
                </b-col>
                <b-col align-self="center">
                  <b-row style="justify-content: left" class="pt-2">
                    Free US shipping for $50 or above. Worldwide Shipping.
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>





          <b-row class="pb-5 pt-3 pl-3 pr-3 mt-5" style='background-color: rgb(255, 243, 231)'>
            
                <b-col
                  cols="12"
                  class="pt-4 pb-4 pl-0 pr-0"
                  v-for="(item, index) in inventory_pro"
                  :key="index"
                  style="max-width: 1080px; margin: 0 auto"
                >
                  <b-row
                class="pl-3 pt-0 reduced_pl_pr"
                style="font-size: 28px; padding-bottom: 1px"
              >
                <b style="font-size: 33px; padding-bottom: 1px" class="h1-font"
                  >Skin Collections</b
                >
                <b-col cols="auto">
                  <b-img
                    src="img/new_149.png"
                    style="width: 40px; height: auto"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col style="" class="pl-pr-0-sm">
                  Our most popular Skins in a bundle. Bundle and save! Give your Tracker a new look!

                </b-col>
              </b-row >
                  <b-row class='mt-4'>
                    <b-col style="background-color: white; border-radius: 10px">
                      
                      <b-row class="pb-5 pt-3">
                        <b-col md="6" cols="12" class="hide-when-small">
                          <b-row>
                            <b-col>
                              <b-img
                                center
                                class="image_bundle"
                                fluid
                                :src="getImage2(item)"
                              ></b-img>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 21px;
                                text-align: center;
                              "
                            >
                              What's in the Bundle?
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 0) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 1) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 2) }}
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 1 && index<2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (US/CA/MX)
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 2 && index<2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (AU/NZ)
                            </b-col>
                          </b-row>
                          <b-row class="pt-2">
                            <b-col
                              cols="8"
                              style="
                                color: #323436;
                                font-size: 12px;
                                text-align: center;
                                margin: 0 auto;
                              "
                            >
                              {{ getH4(item) }}
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col md="6" cols="12" class="pl-0 pr-0">
                          <b-row v-if="item.list.length > 1" class="pt-2">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436">
                                Select number of
                              </span>
                              <span
                                style="color: #2f95eb; padding-left: 7px"
                                v-if="index == 0"
                              >
                                Pro Trackers
                              </span>
                              <span
                                style="color: #2f95eb; padding-left: 7px"
                                v-if="index == 1"
                              >
                                Classic Trackers
                              </span>
                            </b-col>
                          </b-row>
                          <b-row v-if="item.list.length > 1">
                            <b-col
                              style=""
                              md="3"
                              cols="12"
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in item.list"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.tracker_size_img"
                                style="cursor: pointer"
                                :class="{
                                  'selected-border': index2 == item.index1,
                                }"
                                class="unselected-border"
                                @click="select_bundle_size(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-3">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436"> Select </span>
                              <span
                                style="color: #fb870c"
                                class="pl-2 pr-2"
                                v-if="index == 0"
                                >Skin</span
                              >
                              <span
                                style="color: #fb870c"
                                class="pl-2 pr-2"
                                v-else
                                >Design</span
                              >
                              <span style="color: #323436" class="pr-2">
                                options
                              </span>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              md="3"
                              cols="12"
                              style=""
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in item.list[item.index1]
                                .skus"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.tracker_skin_img"
                                style="cursor: pointer"
                                class="unselected-border"
                                :class="{
                                  'selected-border': index2 == item.index2,
                                }"
                                @click="select_bundle_design(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-3" v-if="index != 0">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436"> Select </span>
                              <span style="color: #00bea4" class="pl-2 pr-2"
                                >Hub</span
                              >
                              <span style="color: #323436" class="pr-2">
                                options
                              </span>
                            </b-col>
                          </b-row>
                          <b-row v-if="index != 0" class="pb-2">
                            <b-col
                              class="pl-0 pr-0"
                              style="max-width: 500px"
                              v-if="adaptor == 0"
                            >
                              Truthbrush Hub with USB plug. Automatically connects with multiple trackers. Adaptor not included.
                            </b-col>
                            <b-col
                              class="pl-0 pr-0"
                              style="max-width: 500px"
                              v-if="adaptor == 1"
                            >
                              Add a Type A compatible USB power adapter to conveniently plug into a wall outlet (For US, Canada, Mexico, Others)

                            </b-col>
                            <b-col
                              class="pl-0 pr-0"
                              style="max-width: 500px"
                              v-if="adaptor == 2"
                            >
                              Add a Type I compatible USB power adapter to conveniently plug into a wall outlet (For Australia, Others)

                            </b-col>
                          </b-row>
                          <b-row v-if="index != 0">
                            <b-col
                              style=""
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in hub_type"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.image"
                                style="cursor: pointer"
                                class="unselected-border"
                                :class="{
                                  'selected-border': index2 == adaptor,
                                }"
                                @click="select_bundle_hub(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-2">
                            <hr style="width: 100%; height: 1px" />
                          </b-row>
                          <b-row
                            v-if="
                              getCoupon() == 'babysideburns' ||
                              getCoupon() == 'A3KzVdj8'
                            "
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Baby Sideburns Sale!
                            </b-col>
                          </b-row>

                          <b-row
                            v-if="
                              getCoupon() == 'peachjar0427'
                            "
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Extra 20% off for LexRich5!
                            </b-col>
                          </b-row>

                          <b-row
                            v-if="
                              getCoupon() == 'dV7sL3vU'
                            "
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #2F95EB;
                                text-align: center;
                              "
                            >
                              Flash Sale, Extra 10% Off
                            </b-col>
                          </b-row>


                          <b-row
                            v-if="getCoupon() == '5minutesformom'"
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              5 Minutes for Mom Special Price!
                            </b-col>
                          </b-row>
                          <b-row v-if="getCoupon() == 'Sixfr2n3'" class="pb-2">
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Black Friday Sale - Extra 15% Off
                            </b-col>
                          </b-row>

                          <b-row v-if="getCoupon() == 'mylifesuckers'" class="pb-2">
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              MyLifeSuckers - Extra 10% Off
                            </b-col>
                          </b-row>

                          <b-row v-if="getCoupon() == 'TDm1cVpj'" class="pb-2">
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Holiday Sales! - Extra 10% Off
                            </b-col>
                          </b-row>
                          
                          <b-row v-if="calculateFinalPrice(100) == 100">
                            <b-col
                              style="color: #1f2122; font-size: 27px"
                              class="align-center-small pl-0 pr-0"
                            >
                              ${{ getPrice(index, 1) }} (${{
                                getPrice(index, 0)
                              }}
                              value)
                            </b-col>
                          </b-row>

                          <b-row v-else>
                            <b-col
                              style="color: #1f2122; font-size: 25px"
                              class="align-center-small pl-0 pr-0"
                            >
                              ${{ calculateFinalPrice(getPrice(index, 1)) }}

                              <strike>${{ getPrice(index, 0) }}</strike>
                              ({{
                                (
                                  (1 -
                                    calculateFinalPrice(getPrice(index, 1)) /
                                      getPrice(index, 0)) *
                                  100
                                ).toFixed(0)
                              }}% Off)
                            </b-col>
                          </b-row>

                          <b-row class="pt-3 pb-1 pl-0 reduced_pl_pr" style='cursor:pointer' @click="gotoSubscription()" v-if='index!=2'  hidden>
                            <b-col
                              style="background-color: #e7f8fd"
                              class="pt-3 pb-3 pl-pr-0-sm"
                            >
                              <b-row>
                                <b-col
                                  cols="2"
                                  class="reduced_pl_pr"
                                  align-self="center"
                                >
                                  <b-img
                                    src="img/payg-logo.png"
                                    style="max-width: 40px"
                                    center
                                    fluid
                                  ></b-img>
                                </b-col>
                                <b-col cols="10" class="pl-1 pr-0">
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-1"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b style="font-size: 14px">
                                        See new, flexible monthly plans!</b
                                      >
                                    </b-col>
                                  </b-row>
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-0"
                                  >
                                    <b-col
                                      cols="pl-0 pr-1"
                                      style="max-width: 380px"
                                    >
                                      Start for less. Then, pay as low as 99&#162;/mo/user. Cancel any time.
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>

                          <b-row class="pt-2 pb-1 pl-0 reduced_pl_pr">
                            <b-col
                              style="background-color: #e7f8fd"
                              class="pt-3 pb-3 pr-0"
                            >
                              <b-row>
                                <b-col
                                  cols="2"
                                  class="reduced_pl_pr pl-0 pr-1"
                                  align-self="center"
                                >
                                  <b-img
                                    src="img/tb-ic-paypal@2x.png"
                                    style="max-width: 35px"
                                    fluid
                                  ></b-img>
                                </b-col>
                                <b-col cols="10" class="pl-0 pr-0">
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-1"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b style="font-size: 14px">
                                        Buy Now, Pay Later with PayPal</b
                                      >
                                    </b-col>
                                  </b-row>
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-0"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b
                                        style="font-size: 14px; color: #c84141"
                                        v-if="calculateFinalPrice(100) == 100"
                                        >4 interest-free payments of ${{
                                          (getPrice(index, 1) / 4.0).toFixed(2)
                                        }}</b
                                      >
                                      <b
                                        style="font-size: 14px; color: #c84141"
                                        v-else
                                        >4 interest-free payments of ${{
                                          (
                                            calculateFinalPrice(
                                              getPrice(index, 1)
                                            ) / 4.0
                                          ).toFixed(2)
                                        }}</b
                                      >
                                      <b class="hide-when-small">
                                        with Pay in 4</b
                                      >
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col cols="12" class="pl-0 pr-0 pt-3">
                              <b-button
                                pill
                                class="blue-button max-width-sm"
                                style="width: 100%; height: 60px"
                                v-on:click="
                                  onAddCart2(
                                    item,
                                    item.index1,
                                    item.index2,
                                    item.index3
                                  )
                                "
                              >
                                <span style="font-size: 18px">Add to Cart</span>
                              </b-button>
                            </b-col>
                          </b-row>

                          <b-row class="pt-3 hide-when-small">
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                              v-if="index == 0"
                            >
                              Free US Shipping ($50 or above) | Ship Worldwide
                            </b-col>
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                              v-else
                            >
                              Free US Shipping | Ship Worldwide
                            </b-col>
                          </b-row>
                          <b-row class="pt-0 hide-when-small">
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                            >
                              Factory Warranty | 30 Day Guarantee
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col
                          md="6"
                          cols="12"
                          class="pl-pr-0-sm pt-3 hide-when-big"
                        >
                          <b-row class="pt-2">
                            <b-col>
                              <b-img
                                center
                                class="image_bundle"
                                fluid
                                :src="getImage2(item)"
                              ></b-img>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 21px;
                                text-align: center;
                              "
                            >
                              What's in the Bundle?
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 0) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 1) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 2) }}
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 1 && index<2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (US/CA/MX)
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 2 && index<2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (AU/NZ)
                            </b-col>
                          </b-row>
                          <b-row class="pt-2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 12px;
                                text-align: center;
                                margin: 0 auto;
                                max-width: 340px;
                              "
                            >
                              {{ getH4(item) }}
                            </b-col>
                          </b-row>
                          <b-row class="pt-3 hide-when-big">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="pl-0 pr-0"
                              v-if="index == 0"
                            >
                              Free US Shipping Above $50 | Ship Worldwide
                            </b-col>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="pl-0 pr-0"
                              v-else
                            >
                              Free US Shipping | Ship Worldwide
                            </b-col>
                          </b-row>
                          <b-row class="pt-0 hide-when-big">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="pl-0 pr-0"
                            >
                              Factory Warranty | 30 Day Guarantee
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
          

          <b-row class="pt-5">
            <b-col cols="12" class="pl-0 pr-0">
              <b-row class="justify-content-center main-jumbotron pt-3">
                <h1 style="max-width: 100%" class="h1-font">
                  Give Your Truthbrush Tracker A New Look
                </h1>
              </b-row>
              <b-row
                class="
                  justify-content-center
                  align-center
                  pt-2
                  pl-3
                  pr-3
                  h4-font
                "
                style="
                  max-width: 700px;
                  margin: auto !important;
                  font-size: 18px;
                "
              >
                The Truthbrush Skin is designed for both the Truthbrush Pro and
                the Truthbrush models. Replacing the Skin is easy and fun. We
                will be rolling out new designs frequently. Choose the ones your
                kids love and keep them motivated and engaged.
              </b-row>
            </b-col>
            <b-col cols="12" class="pl-0 pr-0 pt-5">
              <carousel
                :perPageCustom="[
                  [320, 1],
                  [600, 2],
                ]"
                :paginationEnabled="true"
                :paginationActiveColor="paginationColor"
                :paginationPadding="5"
                :autoplay="false"
                :autoplayHoverPause="false"
                :autoplayTimeout="8000"
                :loop="false"
                :speed="500"
                :spacePadding="20"
                :minSwipeDistance="24"
                :spacePaddingMaxOffsetFactor="1"
                style="width: 100%"
              >
                <slide class="slide pl-2 pr-2">
                  <b-container class="blue-shadow pt-5 pb-5 pl-0 pr-0">
                    <b-row style="text-align: center">
                      <b-col>
                        <h1>For Classic Tracker</h1>
                      </b-col>
                    </b-row>
                    <b-row class="pt-4">
                      <b-col>
                        <b-img
                          src="img/skin-assemble1.png"
                          center
                          fluid
                          class="skin_caousel"
                        ></b-img>
                      </b-col>
                    </b-row>
                    <b-row class="pt-4">
                      <b-col class="pl-0 pr-0">
                        <b-img
                          src="img/skin-assem3.png"
                          center
                          fluid
                          class="skin_caousel"
                        ></b-img>
                        <b-row>
                          <b-col style="text-align: center">
                            Remove old skin from Tracker
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="pl-0 pr-0">
                        <b-img
                          src="img/skin-assem4.png"
                          center
                          fluid
                          class="skin_caousel"
                        ></b-img>
                        <b-row>
                          <b-col style="text-align: center">
                            Slide Tracker into Skin as indicated
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="pt-4">
                      <b-col>
                        <b-img
                          src="img/skin-assem2.png"
                          center
                          fluid
                          class="skin_caousel"
                        ></b-img>
                        <b-row>
                          <b-col style="text-align: center">
                            Making sure the 'arrow' pointing the 'dot'
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-container>
                </slide>

                <slide class="slide pl-2 pr-2">
                  <b-container class="blue-shadow pt-5 pb-5 pl-0 pr-0">
                    <b-row style="text-align: center">
                      <b-col>
                        <h1>For Truthbrush Pro</h1>
                      </b-col>
                    </b-row>
                    <b-row class="pt-4">
                      <b-col>
                        <b-img
                          src="img/skin-assemble2.png"
                          center
                          fluid
                          class="skin_caousel"
                        ></b-img>
                      </b-col>
                    </b-row>
                    <b-row class="pt-4">
                      <b-col class="pl-0 pr-0">
                        <b-img
                          src="img/skin-assem1.png"
                          center
                          fluid
                          class="skin_caousel"
                        ></b-img>
                        <b-row>
                          <b-col style="text-align: center">
                            Remove back cover with tool
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="pl-0 pr-0">
                        <b-img
                          src="img/skin-assem6.png"
                          center
                          fluid
                          class="skin_caousel"
                        ></b-img>
                        <b-row>
                          <b-col style="text-align: center">
                            Fasten with a coin until dots line up
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="pt-4">
                      <b-col>
                        <b-img
                          src="img/skin-assem5.png"
                          center
                          fluid
                          class="skin_caousel"
                        ></b-img>
                        <b-row>
                          <b-col style="text-align: center">
                            Slide Tracker Pro into Skin as indicated
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-container>
                </slide>
              </carousel>
            </b-col>
          </b-row>

          <b-row
            style="width: 100%; position: relative; padding-bottom: 60px"
            align-h="center"
            class="main-jumbotron reduced-pb-0 pt-5"
          >
            <b-col cols="12">
              <b-row
                class="blue-text justify-content-center"
                style="color: #12b8ed"
              >
                Truthbrush Skin
              </b-row>

              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 820px; color: black; text-align: center">
                  Give your Truthbrush Tracker
                </h1>
              </b-row>
              <b-row>
                <b-col>
                  <b-img src="img/newlook.png" center style="max-width: 240px">
                  </b-img>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" class="skin-canvas mt-3" style="height: 600px">
              <b-row style="height: 100%">
                <b-col
                  cols="12"
                  class="pt-3"
                  style="text-align: center"
                  align-self="end"
                >
                  <b-row>
                    <b-col alicn-self="center" class="h1-skin-text">
                      Fit Truthbrush Tracker and Tracker Pro
                    </b-col>
                  </b-row>
                  <b-row class="mt-5 mb-5">
                    <b-col>
                      <b-button
                        pill
                        variant="primary"
                        size="lg"
                        class="hub-blue btn-truthbrush select-btn"
                        @click="scrollTop()"
                        >Select Skin</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="pt-5">
            <b-col class="pl-0 pr-0">
              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 100%; text-align: center" class="h1-font">
                  Frequently Asked Questions
                </h1>
              </b-row>
              <b-row class="pl-5 pr-5 reduced_pl_pr">
                <VueFaqAccordion
                  :items="myItems"
                  :activeColor="activeColorAccordian"
                  :borderColor="borderColorAccordian"
                />
              </b-row>
              <b-row style="justify-content: center" class="pt-5 pb-5">
                <a href="/#/faq">Visit our FAQ section</a>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>

      <b-row>
        <Checkout-Express id="my-modal" ref="my-modal"> </Checkout-Express>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import CheckoutExpress from "./../components/CheckoutExpress";
import storage from "../storage";
import store from "../store";
import VueFaqAccordion from "vue-faq-accordion";
import { Carousel, Slide } from "vue-carousel";
import env from "./../env";
export default {
  name: "ProductSelect",
  components: {
    NavHeader,
    NavFooter,
    VueFaqAccordion,
    CheckoutExpress,
    Carousel,
    Slide,
  },
  data() {
    return {
      show: false,
      hoverindex: 0,
      paginationColor: "#12B8ED",
      activeColorAccordian: "#000000",
      borderColorAccordian: "#d9dadb",
      extrasensorclass: [false, false, false, false, false, false, false],
      myItems: [
        {
          title: "1. Will the Skin fit on my Truthbrush Pro Tracker?",
          value:
            "Yes. The skin is designed to work with the Truthbrush Pro tracker. Fitting it on is easy and fun, and requires a special back cover that is provided with the skin.",
        },
        {
          title: "2. Will the Skin fit on my Truthbrush Tracker (Non-Pro)?",
          value:
            "Yes. The skin is compatible with the Truthbrush Tracker. Simply replace the old skin with the new skin. Instruction for placing the skin can be found on the Skin's packaging.",
        },
        {
          title: "3. Will my Tracker be water resistant after replacing Skin?",
          value:
            "Yes. Water resistance is designed into tracker's plastic housing. Replacing Skin will not affect its water resistance level.",
        },
        {
          title: "4. What are the Skins made of?",
          value:
            "They are made of premium silicone material that is safe and with high degree of elasticity.",
        },
        {
          title:
            "5. My Classic Tracker already comes with a Skin that is fitted on. Can I still buy and use extra Skin?",
          value:
            "Yes. You can still replace skins even if you are using the Classic Tracker.",
        },
      ],
      stripe: null,
      adaptor: 0,
      hub_type: [
        {
          image: "/img/products/travel_hub.png",
        },

        {
          image: "/img/products/hub_adaptor_type_1.png",
        },

        {
          image: "/img/products/hub_adaptor_type_i.png",
        },
      ],
            inventory_pro: [
        
        // skin bundle
        {
          h1: "Our most popular Skins. Fit for both Tracker Pro and Classic Tracker models. Give your Tracker a new look!",
          index1: 0,
          index2: 1,
          index3: 0,
          list: [
            {
              h2: "Skin collections",
              tracker_size_img: "/img/products/bundle_pro_3.png",
              tracker_size_hide: true,
              skus: [
                {
                  tracker_skin_img: "/img/products/skin_collection_1.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_1",
                      base_price: 34.93,
                      list_price: 23.74,
                      h3: "The classic-7 Skin Bundle | Unicorn, Astronaut, Peacock, Orange, Heart, Dinosaur, Flamingo",
                      image: "/img/products/skin_collection_1.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/skin_collection_3.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_3",
                      base_price: 29.94,
                      list_price: 21.99,
                      h3: "6 Skin Bundle | Penguin, Foxcream, Peacock, Flamingo, Unicorn, Panda",
                      image: "/img/products/skin_collection_3.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/skin_collection_4.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_4",
                      base_price: 29.94,
                      list_price: 21.99,
                      h3: "6 Skin Bundle | Astronaut, Dinosaur, Baseball, Football, Flag, Monster Truck",
                      image: "/img/products/skin_collection_4.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/skin_collection_5.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_5",
                      base_price: 29.94,
                      list_price: 21.99,
                      h3: "6 Skin Bundle | Mermaid, Griffin, Daisy, Peacock, Panda, Orange",
                      image: "/img/products/skin_collection_5.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/skin_collection_6.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_6",
                      base_price: 29.94,
                      list_price: 21.99,
                      h3: "6 Skin Bundle | Monkey King, Orca, Snowy Owl, Axolotl, Penguin, Monster Truck",
                      image: "/img/products/skin_collection_6.png",
                    },
                  ],
                },
                /*
                {
                  tracker_skin_img: "/img/products/skin_collection_2.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_2",
                      base_price: 63.85,
              list_price: 51.08,
                      h3: "All 15 Skins | Unicorn, Astronaut, Peacock, Orange, Heart, Dinosaur, Flamingo, Baseball, Football, Foxcream, Monster Truck, Panda, Penguin, Surfboard, Flag",
                      image: "/img/products/skin_collection_2.png",
                    },
                  ],
                },
                */
              ],
            },
          ],
        },
        //{},
      ],
    };
  },
  methods: {
    onAddCart2(item, index1, index2, index3) {
      var sku = {};
      var obj = item.list[index1].skus[index2].opt[index3];
      sku.id = obj.skuid;
      sku.image = obj.image;
      sku.metadata = {};
      sku.metadata.image0 = obj.image;
      sku.productname = item.list[index1].h2;

      sku.attributes = {};
      sku.attributes.Style = obj.h3;
      sku.price = obj.list_price * 100;
      var list = [];
      list.push({ sku: sku, quantity: 1 });

      if (this.adaptor == 1) {
        let adaptor_us = store.state.inventory.adaptor_us;
        adaptor_us.metadata = {};
        adaptor_us.metadata.image0 = adaptor_us.images[0];
        list.push({ sku: adaptor_us, quantity: 1 });
      } else if (this.adaptor == 2) {
        let adaptor_au = store.state.inventory.adaptor_au;
        adaptor_au.metadata = {};
        adaptor_au.metadata.image0 = adaptor_au.images[0];
        list.push({ sku: adaptor_au, quantity: 1 });
      }

      storage.onAddCart(list, this);
    },
    select_bundle_design(item, index) {
      item.index2 = index;
    },
    getPrice(index, mode) {
      var index1 = this.inventory_pro[index].index1;
      var index2 = this.inventory_pro[index].index2;
      var index3 = this.inventory_pro[index].index3;

      var adaptorloading = 0;
      if (this.adaptor > 0) {
        adaptorloading = 4.99;
      }

      if (mode == 0) {
        return (
          this.inventory_pro[index].list[index1].skus[index2].opt[index3]
            .base_price + adaptorloading
        ).toFixed(2);
      } else if (mode == 1) {
        return (
          this.inventory_pro[index].list[index1].skus[index2].opt[index3]
            .list_price + adaptorloading
        ).toFixed(2);
      }
    },
    getImage(item) {
      return item.list[item.index].image;
    },
    getImage2(item) {
      return item.list[item.index1].skus[item.index2].opt[item.index3].image;
    },
    getImage3(item, index) {
      return item.opt[index].image;
    },
    getH3(item, i) {
      var str = item.list[item.index1].skus[item.index2].opt[item.index3].h3;
      var list = str.split("|");
      if (list.length > i) {
        return list[i].trim();
      } else {
        return "";
      }
    },
    getH4(item) {
      var str = item.list[item.index1].skus[item.index2].opt[item.index3].h3;
      if (str.toLowerCase().includes("skin bundle")) {
        return "Designed for both Pro and Classic trackers";
      }
      var list = str.split("|");
      if (list.length > 0) {
        var first = list[0].split(" ")[0];
        return (
          "Ready for " +
          first +
          " users. App free to use. Support all types of toothbrushes, manual or electric."
        );
      } else {
        return "Ready to use. App is free.";
      }
    },
    getCoupon() {
      //console.log("get:" + store.state.couponid);
      return store.state.couponid;
    },
    calculateFinalPrice(p) {
      var new_p = p * (1 - store.state.discount_percent);
      return new_p.toFixed(2);
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    getskinskulist() {
      return store.state.skinskulist;
    },
    getStock() {
      return this.$store.state.stock;
    },
    getselectedsku(index) {
      return index == this.$store.state.selectedindex;
    },
    clicksku(index) {
      storage.clicksku(index, true);
      this.hoversample(0)
    },
    isDiscount() {
      if (store.state.discount_percent > 0) {
        return true;
      } else {
        return false;
      }
    },
    getDiscountSkinPrice(dis) {
      var sku = store.state.skinskulist[store.state.selectedindex];
      if (sku == null) return 3.99;
      var price = sku.price;
      if (dis) {
        var off = store.state.discount_percent;
        var price_discounted = price - price * off;
        return (price_discounted / 100).toFixed(2);
      } else {
        return (price / 100).toFixed(2);
      }
    },
    getproductInfo() {
      var prodname = "";
      if (store.state.skinskulist.length == 0) {
        return prodname;
      }
      var sku = store.state.skinskulist[store.state.selectedindex];
      prodname = "Skin - " + sku.attributes.Style + " ";
      /*
      var price = sku.price;
      var price_full = price;
      var off = store.state.discount_percent;
      var price_discounted = price - price * off;

      if (price_full == price_discounted) {
        prodname += " $" + (price_full / 100).toFixed(2);
      } else {
        prodname += " $" + (price_discounted / 100).toFixed(2);
      }
*/
      if (sku.inventory!=null && sku.inventory.quantity == "0") {
        prodname += " (sold out) ";
      }

      return prodname;
    },
    getSelectProductClass(index) {
      //console.log(index + " " + this.selectedproduct);
      if (this.selectedproduct == index) {
        return "product-select-box2";
      }
      return "product-select-box";
    },
    setUnderline(index, val) {
      this.extrasensorclass = [false, false, false, false, false, false, false];
      this.extrasensorclass[index] = val;
    },
    shuffleArray(array) {
      for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
    },
    onAddCart() {
      var sku = this.getskinskulist()[this.$store.state.selectedindex];
      var list = [];
      sku.metadata = {};
      sku.metadata.image0 = sku.images[0];
      list.push({ sku: sku, quantity: 1 });
      storage.onAddCart(list, this);
    },

    hoversample(index) {
      this.hoverindex = index;
    },
    selectedimage() {
      var arr = storage.selectedimage(true);
      if (arr.length <= this.hoverindex) {
        this.hoverindex = 0;
      }
      return arr;
    },
    getProductDescription() {
      var selectedproduct = this.$store.selectedproduct;
      if (selectedproduct == null) return;
      return selectedproduct.description;
    },

    getSwatch(sku) {
      return sku.metadata.image0;
    },
    shown() {},
  },
  mounted() {
    var context = this;
    //context.show = true;

    var stripekey = env.stripe_public_key;
    this.$loadScript(
      "https://js.stripe.com/v3/" // production
    ).then(() => {
      //console.log("stripe loaded");
      context.stripe = window.Stripe(stripekey, {
        apiVersion: "2020-08-27",
      });
    });

    this.$loadScript("https://www.paypalobjects.com/api/checkout.js").then(
      () => {}
    );

    storage.clearstorestate();
    
    for (const key in store.state.inventory.skin) {
      let obj =  store.state.inventory.skin[key];
      obj.productid = "prod_0000";
      store.state.skinskulist.push(obj);
    }
    context.shuffleArray(store.state.skinskulist);
    this.clicksku(0, true);

    storage.processCoupon();
    storage.saveCart2Store(this);
  },
};
</script>

<style lang="scss">
.bundle-h2 span,
.bundle-h2 {
  font-size: 20px;
  font-weight: 700;
}
.selected-border {
  border: 3px solid !important;
  border-color: #fec131 !important;
  border-radius: 10px;
}

.unselected-border {
  border: 2px solid;
  border-color: #dfe0e1;
  border-radius: 10px;
}

.bundle-cell {
  max-width: 20%;
  padding-left: 0;
  padding-right: 10px;
}

.swatch-thumbnail{
    width: 100%;
  max-width: 120px;
}
.skin-canvas {
  background-image: url(/img/skin-curve-min.png), url(/img/skin-bk2-min.png),
    linear-gradient(
      180deg,
      rgba(251, 81, 18, 0.3) 0%,
      rgba(87, 156, 110, 0.289843) 54.17%,
      rgba(75, 92, 243, 0.28125) 99.99%,
      rgba(255, 255, 255, 0) 100%
    );
  background-blend-mode: normal, overlay;
  background-size: contain, cover, auto;
  background-repeat: no-repeat;
  background-position: center, bottom, center;
}

.reduced-padding-thumbnail {
  padding: 2% !important;
}

.skin_caousel {
  width: 100%;
  max-width: 160px !important;
}

.abouthero {
  background-color: black;
}
.spec .col-12 {
  text-align: center;
}

.swatch_small_single_display_skin {
  width: 90% !important;
  height: auto !important;
  padding: 5px !important;
}

@media (max-width: 768px) {
  .bundle-h2 span,
  .bundle-h2 {
    font-size: 16px;
    font-weight: 700;
  }
    .bundle-cell {
    max-width: 25%;
    padding-left: 2px;
    padding-right: 5px;
  }

  .padding-top-when-small {
    padding-top: 15px;
  }
  .pl-pr-0-sm {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .skin-canvas {
    background-image: url(/img/skin-curve-min.png), url(/img/skin-bk2-min.png),
      linear-gradient(
        180deg,
        rgba(251, 81, 18, 0.3) 0%,
        rgba(87, 156, 110, 0.289843) 54.17%,
        rgba(75, 92, 243, 0.28125) 99.99%,
        rgba(255, 255, 255, 0) 100%
      );
    background-blend-mode: normal, overlay;
    background-size: 230%, cover, auto;
    background-repeat: no-repeat;
    background-position: center, bottom, center;
    height: 300px !important;
  }

  .h1-skin-text {
    display: none;
  }
}
@media (max-width: 1199px) {
  .aboutmaintext {
    color: black;
    font-size: 20px;
    padding-left: 5%;
    padding-right: 5%;
  }
  .featuretitle {
    font-size: 20px !important;
    padding-bottom: 10px;
  }
  .featuredescription {
    color: #696871;
    font-size: 14px !important;
    padding-bottom: 25px;
  }
  .no-v-padding-small {
    padding-top: 0 !important;
  }
  .reduce-font-small {
    font-size: 24px !important;
  }
}
@media (max-width: 768px) {
  .reduced-pt-small {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .trackerfeature,
  .trackerfeature > .row > .col-sm-6 > .row > .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .reduced-padding-top {
    padding-top: 30px !important;
  }
  .trackerfeature > .row > .col-md-6 > .row > .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .thumbnail-skin {
    padding-left: 5px;
    padding-right: 5px;
  }
}
@media (min-width: 1200px) {
  .aboutmaintext {
    color: black;
    font-size: 24px;
    padding-left: 15%;
    padding-right: 15%;
  }
}
.productcell {
  border-radius: 20px;
  background-color: #f0f4f5;
  width: 100%;
  height: 100%;
}
.productcellwhole:hover {
  border: 2px solid #2ebfde !important;
  cursor: pointer;
  border-radius: 20px;
}
.productcellwhole {
  border: 2px solid white !important;
  cursor: pointer;
  border-radius: 20px;
}
.activeskuskin {
  border: 3px solid #2ebfde !important;
  border-radius: 60px !important;
}
.inactiveskuskin {
  border: 3px solid transparent;
  border-radius: 60px !important;
  padding: 5%;
}
.position-absolute {
  position: fixed !important;
}
.b-overlay .spinner-border {
  color: #2ebfde !important;
}
.featuretitle {
  color: #19191b;
  font-size: 24px;
  padding-bottom: 10px;
}
.featuredescription {
  color: #696871;
}
.breadcrumb-item a {
  color: #05c5ee;
}
.breadcrumb-item {
  font-size: 16px;
}
.breadcrumb {
  background-color: transparent !important;
}
.overlay-blur {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
  color: rgba(130, 130, 130, 0.5);
  font-size: 50px;
  text-align: center;
  line-height: 100px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);
}
.underline-blue {
  border: 2px solid;
  border-color: #05c5ee;
  padding: 0px;
}
.b-overlay .spinner-border {
  color: #2ebfde !important;
}
@media (max-width: 1199px) {
  .cart-nav {
    padding: 0.5rem 15px !important;
  }
  .hide-when-small-1200 {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .cart-nav {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
  }
  .hide-when-big-1200 {
    display: none;
  }
}
@media only screen and (min-width: 1440px) {
  .cart-nav {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
  }
  .b-nav-dropdown ul {
    display: none !important;
  }
}
.breadcrumb {
  padding-left: 0.5rem;
}
a {
  color: #12b8ed;
}
.product-select-box {
  border-radius: 5px;
  border: 4px solid;
  border-color: #bdbdbd;
  background-color: white;
}
.product-select-box2 {
  border-radius: 5px;
  border: 4px solid;
  border-color: #12b8ed;
  background-color: white;
}
hr {
  border-top: 1px solid #bdbdbd;
}
.faq-wrapper {
  max-width: 100% !important;
}
.accordion {
  border: 0px solid !important;
}
.accordion__title-text {
  font-size: 24px !important;
  text-align: left !important;
}
@media (max-width: 768px) {
  .no-max-width-small {
    max-width: 100% !important;
  }
  #my-modal {
    padding-left: 0 !important;
  }

  .reduced_pl_pr {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .accordion__title {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .h1-font {
    font-size: 28px !important;
    font-weight: 600 !important;
  }
  .h2-font {
    font-size: 24px !important;
  }
  .h3-font {
    font-size: 20px !important;
    font-weight: 600 !important;
  }
  .h4-font {
    font-size: 16px !important;
    text-align: left !important;
    width: 100%;
  }
  .accordion__title-text {
    font-size: 16px !important;
    text-align: left !important;
  }
  .image-side-2-side {
    max-height: 200px !important;
    max-width: 50%;
  }
  .full-width {
    width: 100% !important;
  }
  .accordion__toggle-button {
    text-align: left !important;
  }
}
.blue-button,
.blue-button:hover {
  background-color: #12b8ed;
  border: none;
  padding: 12px 60px;
}

.full-width.blue-button {
  width: 100%;
  max-width: 500px;
  height: 60px;

  span {
    font-size: 18px;
  }
}

.underlinestyle {
  border-bottom: 2px solid #12b8ed;
}

.modal-backdrop {
  opacity: 0.85 !important;
}
</style>